const defaultHref = (el) => el.dataset.appIcon || '/brand-assets/icono-actichat-norma.svg';
const badgeHref = (el) => el.dataset.appIconBadge || '/brand-assets/icono-actichat-norma-badge.svg';

export const showBadgeOnFavicon = () => {
  document.querySelectorAll('.favicon').forEach((favicon) => {
    favicon.href = badgeHref(favicon);
  });
};

export const initFaviconSwitcher = () => {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      document.querySelectorAll('.favicon').forEach((favicon) => {
        favicon.href = defaultHref(favicon);
      });
    }
  });
};
